import { ShieldCheck, Lock, PhoneCall, UserCog } from "lucide-react";

const ITEMS = [
  { icon: ShieldCheck, title: "256-bit TLS encryption", body: "All data encrypted in transit" },
  { icon: Lock, title: "PCI-compliant payments", body: "Card processing secured by Stripe" },
  { icon: PhoneCall, title: "Carrier-grade telephony", body: "Voice & SMS powered by Twilio" },
  { icon: UserCog, title: "Role-based access", body: "Granular permissions per team member" },
];

const TrustStrip = () => (
  <section className="bg-[#0F172A] py-14 md:py-16" data-testid="trust-strip">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
        {ITEMS.map((it) => (
          <div key={it.title} className="flex items-start gap-3.5">
            <div className="w-10 h-10 rounded-xl bg-white/[0.07] border border-white/10 flex items-center justify-center shrink-0">
              <it.icon className="w-5 h-5 text-sky-400" />
            </div>
            <div>
              <h3 className="text-[15px] font-semibold text-white mb-0.5">{it.title}</h3>
              <p className="text-[13px] text-slate-400 leading-relaxed">{it.body}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default TrustStrip;
